export default __webpack_public_path__ + "static/media/mapMarker.531181f3.png";